/* models/axes/linear_axis.js */ function _(require, module, exports) {
    const axis_1 = require(141) /* ./axis */;
    const continuous_axis_1 = require(146) /* ./continuous_axis */;
    const basic_tick_formatter_1 = require(106) /* ../formatters/basic_tick_formatter */;
    const basic_ticker_1 = require(102) /* ../tickers/basic_ticker */;
    class LinearAxisView extends axis_1.AxisView {
    }
    exports.LinearAxisView = LinearAxisView;
    LinearAxisView.__name__ = "LinearAxisView";
    class LinearAxis extends continuous_axis_1.ContinuousAxis {
        constructor(attrs) {
            super(attrs);
        }
        static init_LinearAxis() {
            this.prototype.default_view = LinearAxisView;
            this.override({
                ticker: () => new basic_ticker_1.BasicTicker(),
                formatter: () => new basic_tick_formatter_1.BasicTickFormatter(),
            });
        }
    }
    exports.LinearAxis = LinearAxis;
    LinearAxis.__name__ = "LinearAxis";
    LinearAxis.init_LinearAxis();
}
